import { styled } from '@root/stitches.config';
import { Text } from '@components/atoms/text/Text';

export const SignAsideTitle = styled('div', {
  height: '100%',
  display: 'flex',
  flexDirection: 'column',

  svg: {
    width: '180px',
    height: '100px',
    fill: 'white',
  },
});

export const SignAsideContent = styled('div', {
  position: 'relative',
  width: '100%',
  height: '40px',
  width: '100%',

  '@bp2': {
    maxWidth: '340px',
    height: 'auto',
  },
});

export const SignAsideWrapper = styled('div', {
  position: 'relative',
  margin: 0,
  padding: '$24',
  backgroundRepeat: 'no-repeat',
  backgroundSize: `cover`,
  backgroundImage: `url("data:image/svg+xml,%3Csvg width='368' height='710' viewBox='0 0 368 710' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cmask id='mask0' mask-type='alpha' maskUnits='userSpaceOnUse' x='0' y='0' width='368' height='710'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M368 0L368 710H0L0 0L368 0Z' fill='black'/%3E%3C/mask%3E%3Cg mask='url(%23mask0)'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M375 0L375 812H0L0 0L375 0Z' fill='black'/%3E%3Cg filter='url(%23filter0_d)'%3E%3Cpath d='M467 -43.8223C467 -43.8223 443.994 109.852 315.628 137.072C187.262 164.292 64.8771 154.57 -57.5082 314L-481 314L-481 -279L467 -279L467 -43.8223Z' fill='url(%23paint0_linear)'/%3E%3C/g%3E%3Cg opacity='0.2' filter='url(%23filter1_d)'%3E%3Cpath d='M-384 182.816C-384 182.816 -310.023 77.2561 -202.322 60.9501C-94.6198 44.6441 66.3886 -38.0414 107.729 -87L310.077 -87C310.077 -87 243.716 46.8202 31.576 107.746C-180.564 168.672 -384 182.816 -384 182.816Z' fill='%23D6D6D6'/%3E%3C/g%3E%3C/g%3E%3Cdefs%3E%3Cfilter id='filter0_d' x='-489' y='-291' width='964' height='609' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3E%3CfeOffset dy='-4'/%3E%3CfeGaussianBlur stdDeviation='4'/%3E%3CfeColorMatrix type='matrix' values='0 0 0 0 0.121569 0 0 0 0 0.121569 0 0 0 0 0.121569 0 0 0 0.1 0'/%3E%3CfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow' result='shape'/%3E%3C/filter%3E%3Cfilter id='filter1_d' x='-392' y='-99' width='710.077' height='285.816' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3E%3CfeOffset dy='-4'/%3E%3CfeGaussianBlur stdDeviation='4'/%3E%3CfeColorMatrix type='matrix' values='0 0 0 0 0.121569 0 0 0 0 0.121569 0 0 0 0 0.121569 0 0 0 0.1 0'/%3E%3CfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow' result='shape'/%3E%3C/filter%3E%3ClinearGradient id='paint0_linear' x1='-324.843' y1='1254.82' x2='759.106' y2='1027.96' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23111111'/%3E%3Cstop offset='1' stop-color='%23272727'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E%0A")`,

  '@bp2': {
    padding: '$72 $24',
    display: 'flex',
    position: 'relative',
    justifyContent: 'center',
    //alignItems: 'center',
  },
});

export const SignAsideImage = styled('div', {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
});

export const OnboardingSteps = styled('ul', {
  display: 'none',
  '@bp2': {
    display: 'block',
  },
});

export const SignAsideTitleLabel = styled(Text, {
  display: 'none',
  '@bp2': {
    display: 'block',
    fontSize: '$24',
    color: '$white',
    letterSpacing: '1.4px',
    lineHeight: '1.2',
    fontFamily: '$ArtifaktLegendExtraBold',
    mb: '$16',
  },
});

export const OnboardingStepItem = styled('li', {
  display: 'grid',
  gridTemplateColumns: '24px 1fr',
  alignItems: 'center',
  marginBottom: '$16',
  color: '$mediumGrey',
  position: 'relative',
  '&:after': {
    content: '""',
    display: 'block',
    width: '4px',
    height: '27px',
    backgroundColor: 'rgb(57, 57, 57)',
    position: 'absolute',
    top: '20px',
    left: '4px',
  },
  '&:last-of-type': {
    '&:after': {
      content: 'none',
    },
  },

  svg: {
    marginRight: '$12',
    height: '12px',
    width: '12px',
    stroke: '$white',
    fill: 'none',
    justifySelf: 'center',
    zIndex: '1',
  },

  variants: {
    isActive: {
      true: {
        color: '$white',
        fontFamily: '$ArtifaktElementBold',
      },
    },
    isCompletedStep: {
      true: {
        color: '$white',
        fontFamily: '$ArtifaktElementBold',
        svg: {
          height: '20px',
          width: '20px',
          stroke: 'none',
        },
      },
    },
  },
});

export const TagsWrapper = styled('div', {
  display: 'none',

  '@bp2': {
    display: 'block',
  },
});
